<template>
  <el-form-item class="index-form_item" 
                :style="{'padding-left': paddingLeft}"
                :class="[formType, `form-label_${textAlign}`]">
    <!-- 左侧标签 -->
    <span class="form-item_label_left" 
          v-if="labelPosition=='left'"
          slot="label"
          :style="{ 
            minWidth: labelWidth,
            textAlign: textAlign
          }">{{labelText}}</span>
    <!-- 表单项内容 -->
    <slot class="form-item_content"></slot>
    <!-- 右侧标签 -->
    <span class="form-item_label_right" 
          v-if="labelPosition=='right'"
          :style="{ 
            minWidth: labelWidth,
            textAlign: textAlign
          }">{{labelText}}</span>
  </el-form-item>
</template>

<script>
export default {
  props: {
    //  标签文本内容
    labelText: {
      type: String,
      default: ""
    },
    //  标签宽度
    labelWidth: {
      type: String,
      default: ""
    },
    //  标签位置(相对于表单项内容)
    labelPosition: {
      type: String,
      default: "left"
    },
    //  标签文本对齐(标签文本相对于标签宽度)
    textAlign: {
      type: String,
      default: "left"
    },
    //  表单项类型
    formType: {
      type: String,
      default: ""
    },
    // 左间距
    paddingLeft: {
      type: String,
      default: ''
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/base_package/IndexFormItem.vue